import { COMMANDER_OVERRIDE } from 'components/deckPage/header/Legality/legality.const'
import { CardType } from 'types/deck'

export const creatEdhrecCardUrl = (card: CardType): string => {
  const canBeCommander =
    (card.types.includes('Creature') && card.superTypes.includes('Legendary')) ||
    card.text.includes('can be your commander') ||
    COMMANDER_OVERRIDE.includes(card.name)

  const cardName = (card.front?.name || card.name)
    .normalize('NFD')
    .toLowerCase()
    .replace(/[^a-zA-Z0-9-_+\s/]/g, '')
    .replace(/\+/g, 'plus ')
    .replace(/[\s/]+/g, '-')

  if (canBeCommander) return `https://edhrec.com/commanders/${cardName}`

  return `https://edhrec.com/cards/${cardName}`
}
